// src/components/ScheduleFollowUpModal.js
import React, { useEffect, useState } from "react";

function createDefaultForm(defaultName, defaultEmail, defaultDate = "", defaultTime = "") {
  return {
    user_name: defaultName,
    email: defaultEmail,
    preferred_date: defaultDate,
    preferred_time: defaultTime,
    session_type: "Coaching Session",
  };
}

export default function ScheduleFollowUpModal({
  open,
  onClose,
  defaultName = "",
  defaultEmail = "",
  defaultDate = "",
  defaultTime = "",
  onBeforeSubmit,
}) {
  const [form, setForm] = useState(createDefaultForm(defaultName, defaultEmail, defaultDate, defaultTime));
  const [sending, setSending] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!open) return;
    setForm(createDefaultForm(defaultName, defaultEmail, defaultDate, defaultTime));
    setErr("");
  }, [open, defaultName, defaultEmail, defaultDate, defaultTime]);

  if (!open) return null;

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    setErr("");
    try {
      if (typeof onBeforeSubmit === "function") {
        await onBeforeSubmit(form);
      }
      onClose(true);
    } catch (ex) {
      setErr(ex.message || "Failed to save follow-up.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={backdrop} onClick={() => onClose(false)} role="presentation">
      <div style={card} role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <h3 style={{ margin: 0 }}>Schedule follow-up</h3>
        <p style={{ marginTop: 6, color: "var(--muted)" }}>
          Save the next in-app follow-up on this session.
        </p>

        <form onSubmit={submit} style={{ display: "grid", gap: 10, marginTop: 8 }}>
          <div>
            <label>Client name</label>
            <input value={form.user_name} onChange={update("user_name")} required />
          </div>
          <div>
            <label>Email</label>
            <input type="email" value={form.email} onChange={update("email")} required />
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div>
              <label>Date</label>
              <input type="date" value={form.preferred_date} onChange={update("preferred_date")} required />
            </div>
            <div>
              <label>Time</label>
              <input type="time" value={form.preferred_time} onChange={update("preferred_time")} required />
            </div>
          </div>
          <div>
            <label>Session type</label>
            <select value={form.session_type} onChange={update("session_type")}>
              <option>Coaching Session</option>
              <option>Game Review</option>
              <option>Progress Check-In</option>
            </select>
          </div>

          {err && <div style={errBox}>{err}</div>}

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 6 }}>
            <button type="button" className="btn btn-ghost" onClick={() => onClose(false)} disabled={sending}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={sending}>
              {sending ? "Saving…" : "Save follow-up"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const backdrop = {
  position: "fixed", inset: 0, display: "grid", placeItems: "center",
  background: "var(--color-overlay)", zIndex: 1000,
};
const card = {
  width: "min(520px, 92vw)", background: "var(--card)", color: "var(--text)",
  border: "1px solid var(--border)", borderRadius: 14, padding: 18,
  boxShadow: "var(--shadow-lg)",
};
const errBox = {
  background: "color-mix(in srgb, var(--color-danger) 8%, var(--ui-surface))",
  border: "1px solid color-mix(in srgb, var(--color-danger) 28%, var(--ui-border))",
  padding: "8px 10px", borderRadius: 8, color: "var(--ui-text)",
};
